import { render, staticRenderFns } from "./EmailOnboardingCheckEmail.vue?vue&type=template&id=7978a36e&"
import script from "./EmailOnboardingCheckEmail.vue?vue&type=script&lang=js&"
export * from "./EmailOnboardingCheckEmail.vue?vue&type=script&lang=js&"
import style0 from "./EmailOnboardingCheckEmail.vue?vue&type=style&index=0&id=7978a36e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports